import { get } from 'lodash';

import { CAMPAIGN_NAMES } from 'constants/personalizations';

const ExperimentsSelector = class {
  static isActive = (state, identifier) =>
    get(state, ['experiments', identifier, 'isActive'], false);

  static experimentOptions = (state, identifier) =>
    get(state, ['experiments', identifier, 'options'], {});

  static showAfterpayAboveReviewsStars = state =>
    ExperimentsSelector.isActive(state, 'showAfterpayAboveReviewsStars');

  static showAfterpayBeneathAddToCart = state =>
    ExperimentsSelector.isActive(state, 'showAfterpayBeneathAddToCart');

  static isPdpUnisexToggleEnabled = state => ExperimentsSelector.isActive(state, 'pdpUnisexToggle');

  static isPdpThumbnailsEnabled = state => ExperimentsSelector.isActive(state, 'pdpThumbnails');

  static isAddToCartModalEnabled = state => {
    // The PDP Add to Cart Modal experience returns 4 variations. The "Control" variation indicates
    // that we should not use any Add To Cart Modal (ie the Add To Cart Modal is disabled).
    // We determine whether or not the Control is returned becuase it has a 0 length variations array.
    const variationName = get(state, [
      'personalizations',
      CAMPAIGN_NAMES.PDP_ADD_TO_CART_MODAL_RECS,
      'variations',
      0,
      'analyticsMetadata',
      'variationName',
    ]);
    return variationName !== 'do_nothing_action' && !!variationName;
  };

  static addToCartModalRecommendationsOption = state => {
    return get(
      state,
      [
        'personalizations',
        CAMPAIGN_NAMES.PDP_ADD_TO_CART_MODAL_RECS,
        'variations',
        0,
        'payload',
        'data',
        'campaignName',
      ],
      ''
    );
  };
};

export default ExperimentsSelector;
